import React from 'react';

import logger from 'lib/logger';
import { loadDojo } from './loadDojo';

type SdkLoadState = 'loading' | 'success' | 'failed';

/**
 * Fetches the Dojo SDK and reports when `window.Dojo` is safe to touch. Every
 * consumer in this folder constructs its form synchronously, so gate them on
 * `isLoaded` rather than awaiting inside each one.
 */
export const useDojoSdk = () => {
    const [loadState, setLoadState] = React.useState<SdkLoadState>('loading');

    React.useEffect(() => {
        let cancelled = false;

        loadDojo()
            .then(() => {
                if (!cancelled) {
                    setLoadState('success');
                }
            })
            .catch(error => {
                logger.error('Dojo ::: Failed to load the Dojo SDK', error);
                if (!cancelled) {
                    setLoadState('failed');
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return { isLoaded: loadState === 'success', hasFailed: loadState === 'failed' };
};
